import { FIND_DRIVER } from "./../../routes";
import customAxios from "../../customAxios";

type Props = {
  page?: string | number;
  limit?: string | number;
  search?: any;
  filters?: any;
  /** selected academic year (سال تحصیلی) _id; omitted means unfiltered */
  academicYear?: string;
  /** also list the previous year's drivers, so they can be carried over */
  includePreviousYear?: boolean;
};

async function findDriver(props: Props) {
  let body: any = {
    page: props.page,
    limit: props.limit,
    userType: "DRIVER",
  };
  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
      // [String(props.search.base)]: utils.convertNumbers2English(
      //   props.search.value
      // ),
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const { province, city, gender, marital, company } = props.filters;
    body = {
      ...body,
      province: province?._id,
      city: city?._id,
      gender: gender?.value,
      marital: marital?.value,
      company: company?._id,
    };
  }
  //console.log(props?.filters?.company?.);

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;
  if (props.includePreviousYear) body.includePreviousAcademicYear = true;

  try {
    return (await customAxios.post(FIND_DRIVER, body)).data;
  } catch (error: any) {
    console.error({ FIND_DRIVER: error });
  }
}

export default findDriver;
